import styled from 'styled-components'
import { theme } from '@/client/components'
const { space, breakpoint } = theme

export const Featured = styled.div`
  @media (min-width: ${breakpoint.lg}) {
    padding-top: ${space.lg};
  }
`
